/*============================================================================
  Cart Drawer Upsell - Quick Add to Cart
  "Votre routine serait plus complète avec" - Ajout en 1 clic avec tracking
  + _trigger : attribution du vrai produit déclencheur (lu depuis data-trigger)
==============================================================================*/

(function() {
  'use strict';

  var selectors = {
    addButton: '.cart-upsell-card__add-btn'
  };

  var classes = {
    loading: 'is-loading',
    success: 'is-success'
  };

  function CartDrawerUpsell() {
    this.init();
  }

  CartDrawerUpsell.prototype = {

    init: function() {
      document.addEventListener('click', this.handleAddClick.bind(this));
      document.addEventListener('CartDrawer:open', this.addCloseButton.bind(this));

      /*============================================================================
        Guard Personal Shopper — ne pas ouvrir le drawer upsell si l'ATC
        vient du personal shopper (from_personal_shopper: true dans le detail)
      ==============================================================================*/
      document.addEventListener('ajaxProduct:added', function(e) {
        if (e.detail && e.detail.from_personal_shopper) {
          setTimeout(function() {
            var headerCart = document.getElementById('HeaderCart');
            if (headerCart && headerCart.classList.contains('is-active')) {
              headerCart.classList.remove('is-active');
            }
          }, 50);
          return;
        }
      });

      this.watchDrawerState();
      this.watchDrawerStateMobile();
      this.observeUpsellSection();
      this.observeReviewsSlider();
    },

    /*============================================================================
      watchDrawerStateMobile (22/09/2026)
      Sur mobile, #HeaderCart garde le positionnement natif du thème :
      position: absolute, ancrée au document. Si le panier s'ouvre après
      avoir scrollé — ATC standard en bas de fiche produit, pas seulement
      notre carte Quick shop —, il apparaît hors écran, au-dessus du
      viewport (aucune requête ratée, juste invisible : bug déjà présent
      sur le parcours d'achat standard, révélé le 22/09/2026). Plutôt que
      de reconstruire le positionnement du panier (risque de casser le
      bouton Fermer, qui vit dans l'en-tête, pas dans le panier), on
      remonte la page en haut dès l'ouverture : le panier retombe pile
      dans le viewport avec son comportement natif inchangé.
    ==============================================================================*/
    watchDrawerStateMobile: function() {
      if (window.innerWidth >= 1024) return;
      var headerCart = document.getElementById('HeaderCart');
      if (!headerCart) return;

      var wasOpen = headerCart.classList.contains('is-active');
      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'attributes' &&
              mutations[i].attributeName === 'class' &&
              mutations[i].target === headerCart) {
            var isOpen = headerCart.classList.contains('is-active');
            if (isOpen && !wasOpen && window.scrollY > 0) {
              window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
            }
            wasOpen = isOpen;
          }
        }
      });
      observer.observe(headerCart, { attributes: true });
    },

    /*============================================================================
      watchDrawerState
      Observe .is-active sur #HeaderCart directement.
      À l'ouverture : déplacer vers body pour sortir du stacking context
      de .header-section (z-index:6 sticky).
      À la fermeture : remettre à sa place d'origine.
    ==============================================================================*/
    watchDrawerState: function() {
      if (window.innerWidth < 1024) return;
      var self = this;

      var headerCart = document.getElementById('HeaderCart');
      if (!headerCart) return;

      this._headerCartParent = headerCart.parentNode;
      this._headerCartNextSibling = headerCart.nextSibling;

      self._syncActiveState(headerCart);

      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'attributes' &&
              mutations[i].attributeName === 'class' &&
              mutations[i].target === headerCart) {
            self._syncActiveState(headerCart);
          }
        }
      });

      observer.observe(headerCart, { attributes: true });
      this._stateObserver = observer;
    },

    _syncActiveState: function(headerCart) {
      if (!headerCart) return;

      var isOpen = headerCart.classList.contains('is-active');

      if (isOpen && headerCart.parentNode !== document.body) {
        this._headerCartParent = headerCart.parentNode;
        this._headerCartNextSibling = headerCart.nextSibling;
        document.body.appendChild(headerCart);
        headerCart.style.top = '38px';
        this.addCloseButton();
      } else if (!isOpen && headerCart.parentNode === document.body) {
        headerCart.style.top = '';
        if (this._headerCartParent) {
          if (this._headerCartNextSibling) {
            this._headerCartParent.insertBefore(headerCart, this._headerCartNextSibling);
          } else {
            this._headerCartParent.appendChild(headerCart);
          }
        }
      }
    },

    /*============================================================================
      MutationObserver — [data-cart-upsell]
    ==============================================================================*/
    observeUpsellSection: function() {
      if (window.innerWidth < 1024) return;

      var self = this;

      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType !== 1) continue;

            var upsellSection = null;
            if (node.hasAttribute && node.hasAttribute('data-cart-upsell')) {
              upsellSection = node;
            } else if (node.querySelector) {
              upsellSection = node.querySelector('[data-cart-upsell]');
            }

            if (upsellSection) {
              if (upsellSection.closest('.cart-upsell-panel')) continue;
              self.moveUpsellToPanel(upsellSection);
              self.addCloseButton();
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
      this._upsellObserver = observer;
    },

    /*============================================================================
      MutationObserver — [data-upsell-reviews]
      Guard : on n'initialise le slider que si le bloc reviews n'est pas déjà
      marqué comme initialisé (_reviewsInitialized). Le déplacement de
      #HeaderCart vers body déclenche le MutationObserver une deuxième fois —
      sans ce guard, initReviewsSlider serait appelé deux fois et deux items
      .is-active se retrouveraient visibles simultanément.
    ==============================================================================*/
    observeReviewsSlider: function() {
      if (window.innerWidth < 1024) return;

      var self = this;

      var existing = document.querySelector('[data-upsell-reviews]');
      if (existing && !existing._reviewsInitialized) {
        existing._reviewsInitialized = true;
        self.initReviewsSlider(existing);
      }

      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType !== 1) continue;

            var reviewsBlock = null;
            if (node.hasAttribute && node.hasAttribute('data-upsell-reviews')) {
              reviewsBlock = node;
            } else if (node.querySelector) {
              reviewsBlock = node.querySelector('[data-upsell-reviews]');
            }

            // Guard : ne pas réinitialiser si déjà initialisé
            if (reviewsBlock && !reviewsBlock._reviewsInitialized) {
              reviewsBlock._reviewsInitialized = true;
              self.initReviewsSlider(reviewsBlock);
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
      this._reviewsObserver = observer;
    },

    /*============================================================================
      Reviews slider — rotation toutes les 7s
      Nettoie toutes les classes .is-active existantes avant de démarrer
      pour éviter tout doublon résiduel.
    ==============================================================================*/
    initReviewsSlider: function(reviewsBlock) {
      var track = reviewsBlock.querySelector('[data-reviews-track]');
      if (!track) return;

      if (this._reviewsTimer) {
        clearInterval(this._reviewsTimer);
        this._reviewsTimer = null;
      }

      var items = track.querySelectorAll('.cart-upsell-reviews__item');
      if (items.length === 0) return;

      // Nettoyer toutes les classes is-active existantes
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('is-active');
      }

      var current = 0;
      items[current].classList.add('is-active');

      this._reviewsTimer = setInterval(function() {
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].classList.add('is-active');
      }, 7000);
    },

    /*============================================================================
      Colonne upsell desktop
    ==============================================================================*/
    moveUpsellToPanel: function(upsellSection) {
      if (window.innerWidth < 1024) return;

      var headerCart = document.getElementById('HeaderCart');
      if (!headerCart) return;
      if (!upsellSection) return;

      var panel = headerCart.querySelector('.cart-upsell-panel');
      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'cart-upsell-panel';
        headerCart.insertBefore(panel, headerCart.firstChild);
      }

      var existing = panel.querySelector('[data-cart-upsell]');
      if (existing && existing !== upsellSection) existing.remove();

      panel.appendChild(upsellSection);
    },

    /*============================================================================
      Bouton fermeture — .js-close-header-cart (bouton natif Fetch)
    ==============================================================================*/
    addCloseButton: function() {
      if (window.innerWidth < 1024) return;

      var headerCart = document.getElementById('HeaderCart');
      if (!headerCart) return;
      if (headerCart.querySelector('.cart-upsell-close-btn')) return;

      var btn = document.createElement('button');
      btn.className = 'cart-upsell-close-btn';
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-label', 'Fermer le panier');
      btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L16 16M16 2L2 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

      btn.addEventListener('click', function() {
        // Fermeture NATIVE du thème : réinitialise aussi l'en-tête (« FERMER X »
        // -> icônes Search / Profil / Panier). Avant, on retirait seulement
        // is-active, ce qui laissait l'en-tête bloqué en mode drawer ouvert.
        var nativeClose = document.querySelector('.js-close-header-cart');
        if (nativeClose) {
          nativeClose.click();
        } else {
          var headerCart = document.getElementById('HeaderCart');
          if (headerCart) headerCart.classList.remove('is-active');
        }
      });

      headerCart.appendChild(btn);
    },

    handleAddClick: function(evt) {
      var btn = evt.target.closest(selectors.addButton);
      if (!btn) return;

      evt.preventDefault();
      evt.stopPropagation();

      if (btn.classList.contains(classes.loading)) return;

      var variantId = btn.dataset.variantId;
      var productTitle = btn.dataset.productTitle;
      var productPrice = btn.dataset.productPrice;

      if (!variantId) {
        console.error('Cart Upsell: Variant ID manquant');
        return;
      }

      this.addToCart(btn, variantId, productTitle, productPrice);
    },

    addToCart: function(btn, variantId, productTitle, productPrice) {
      btn.classList.add(classes.loading);

      var deviceType = window.innerWidth < 768 ? 'mobile' : 'desktop';
      var card = btn.closest('.cart-upsell-card');

      // Produit déclencheur : lu sur la section [data-cart-upsell] (data-trigger)
      var upsellRoot = btn.closest('[data-cart-upsell]');
      var trigger = upsellRoot && upsellRoot.dataset.trigger ? upsellRoot.dataset.trigger : '';

      var props = {
        '_source': 'cart_upsell',
        '_device': deviceType
      };
      if (trigger) props['_trigger'] = trigger;

      var formData = {
        items: [{
          id: variantId,
          quantity: 1,
          properties: props
        }]
      };

      var cartAddUrl = window.theme && window.theme.routes && window.theme.routes.cartAdd
        ? window.theme.routes.cartAdd
        : '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === 422 || data.status === 'bad_request') {
          this.showError(btn, data.description || data.message);
        } else {
          this.markCartWithUpsell();
          this.showSuccess(btn, productTitle, card);
          this.trackUpsellAdd(variantId, productTitle, productPrice, data, deviceType);

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { variant_id: variantId, product: data, from_upsell: true }
          }));
        }
      })
      .catch(error => {
        console.error('Cart Upsell: Erreur ajout panier', error);
        this.showError(btn, 'Une erreur est survenue');
      });
    },

    markCartWithUpsell: function() {
      var cartUpdateUrl = window.theme && window.theme.routes && window.theme.routes.cartChange
        ? window.theme.routes.cartChange.replace('/change.js', '/update.js')
        : '/cart/update.js';

      fetch(cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ attributes: { 'contains_upsell': 'true' } })
      })
      .then(response => response.json())
      .then(() => console.log('Cart Upsell: Attribut "contains_upsell" ajouté'))
      .catch(error => console.error('Cart Upsell: Erreur attribut', error));
    },

    showSuccess: function(btn, productTitle, card) {
      btn.classList.remove(classes.loading);
      btn.classList.add(classes.success);
      console.log('Cart Upsell: Produit ajouté -', productTitle);

      setTimeout(function() {
        if (card) {
          card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          card.style.opacity = '0';
          card.style.transform = 'translateX(8px)';
          setTimeout(function() { card.remove(); }, 300);
        }
      }, 600);
    },

    showError: function(btn, message) {
      btn.classList.remove(classes.loading);
      if (message) { alert(message); }
      console.error('Cart Upsell: Erreur -', message);
    },

    trackUpsellAdd: function(variantId, productTitle, productPrice, productData, deviceType) {
      var priceInEuros = productPrice ? parseFloat(productPrice) / 100 : 0;

      if (typeof gtag !== 'undefined') {
        gtag('event', 'add_to_cart', {
          currency: 'EUR',
          value: priceInEuros,
          items: [{ item_id: variantId, item_name: productTitle, item_category: 'Upsell', price: priceInEuros, quantity: 1 }]
        });
        gtag('event', 'upsell_add_to_cart', {
          variant_id: variantId, product_title: productTitle, value: priceInEuros, device_type: deviceType
        });
      }

      if (typeof ga !== 'undefined') {
        ga('send', 'event', 'Upsell', 'Add to Cart', productTitle, priceInEuros);
      }

      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          event: 'upsell_add_to_cart',
          device_type: deviceType,
          ecommerce: {
            currencyCode: 'EUR',
            add: { products: [{ id: variantId, name: productTitle, price: priceInEuros, quantity: 1, dimension1: 'Upsell' }] }
          }
        });
      }
    }
  };

  function init() {
    if (document.readyState !== 'loading') {
      new CartDrawerUpsell();
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        new CartDrawerUpsell();
      });
    }
  }

  init();

})();

/*============================================================================
  CART REWARDS — paliers panier : échantillon offert (29 €) + livraison (100 €)
  Remplace la barre de l'app Yaco Progress Bar. Markup : header-cart-drawer.liquid
  (bloc CART REWARDS), styles : cart-drawer-upsell.css. Adapté de promo-vitaminec.js
  (4 états, multi-devise EUR/£, tracking, résilience au re-render du drawer).

  États data-state : progress (sous 29, pas d'échantillon) | choose (29 atteint,
  à choisir) | added (échantillon présent, seuil ok) | warning (échantillon
  présent, panier repassé sous 29). data-ship : progress | done (100 atteint).
  L'échantillon offert ne compte pas dans le calcul des seuils.

  EN PRODUCTION depuis le 07/07/2026 ; app Yaco désinstallée le 15/07/2026.
  Coupe-circuit : ?pers-rewards=0 désactive sur le navigateur courant.
  Promo No Blues (16/07 → 28/07/2026) : terminée, bloc retiré.

  + GWP CASQUETTE (04–06/08/2026) : Casquette You Glow offerte dès 80 € d'achat,
    France uniquement, à sélectionner. États data-gwp-state : off | progress
    (teaser) | choose | added. La gratuité est garantie côté serveur par le
    discount automatique « Casquette offerte dès 80 € » (BXGY, prérequis 80 €
    hors casquette) — sous le seuil, elle serait facturée 25 €, d'où le retrait
    automatique. La casquette reste achetable seule : une ligne casquette payée
    (prix > 0, sans propriété _gwp) n'est jamais touchée par ce module.

  + CODE MONSERUM (18–23/08/2026) : Sérum Vitamine C 15 ml offert dès 120 €
    d'achat avec le code, France uniquement. Champ code dans le drawer :
    l'application passe par POST /cart/update.js { discount } (API panier
    Shopify), puis le cadeau est ajouté automatiquement dès que le panier est
    éligible. États data-code-state : off | field | undermin | applied.

  + MARCHÉ US (28/07/2026, demande Clara) : pas d'échantillons pour les
    commandes en USD (marché en-us) — palier échantillon masqué, échantillon
    retiré du panier le cas échéant.
==============================================================================*/

(function () {
  'use strict';

  /* EN PRODUCTION depuis le 07/07/2026. Coupe-circuit conservé :
     ?pers-rewards=0 désactive le module sur le navigateur courant
     (mémorisé en localStorage), ?pers-rewards=1 le réactive. */
  try {
    var gate = location.search.match(/[?&]pers-rewards=(0|1)/);
    if (gate) localStorage.setItem('persRewards', gate[1]);
    if (localStorage.getItem('persRewards') === '0') return;
    document.documentElement.classList.add('pers-rewards-active');
  } catch (e) { document.documentElement.classList.add('pers-rewards-active'); }

  var SAMPLE_T = 2900; // 29 € / £29 en unités mineures
  /* Kit découverte PERS : gratuit voulu (0 € + port), mais 1 seul par panier
     (25/08/2026) — clampé à 1 comme l'échantillon, sans retrait automatique
     (il a le droit de s'acheter seul). */
  var KIT_ID = '48653090324827';
  /* Livraison offerte : seuil par devise, aligné sur les tarifs d'expédition
     Shopify réels (France/Monaco : dès 100 € ; zone UK : dès £85 via DPD). */
  function shipThreshold(cur) { return (cur === 'GBP') ? 8500 : 10000; }

  /* Porte de test par campagne : ?<param>=1 force l'activation avant la date,
     ?<param>=0 coupe (mémorisé en localStorage). */
  function readGate(param, key) {
    try {
      var m = location.search.match(new RegExp('[?&]' + param + '=(0|1)'));
      if (m) localStorage.setItem(key, m[1]);
      return localStorage.getItem(key);
    } catch (e) { return null; }
  }
  function windowOn(gateVal, start, end) {
    if (gateVal === '0') return false;
    if (gateVal === '1') return true;
    var now = Date.now();
    return now >= start && now < end;
  }

  /* GWP CASQUETTE — Casquette You Glow (25 €) offerte dès 80 € d'achat
     (hors casquette), du 04/08 au 06/08/2026 inclus, France uniquement
     (devise EUR + attribut panier « Customer country » posé par Orbe).
     Porte de test : ?pers-cap=1 / ?pers-cap=0. */
  var GWP_T = 8000;
  var GWP_START = new Date('2026-08-04T00:00:00+02:00').getTime();
  var GWP_END = new Date('2026-08-07T00:00:00+02:00').getTime();
  var _gwpGate = readGate('pers-cap', 'persCap');
  function gwpEnabled() { return windowOn(_gwpGate, GWP_START, GWP_END); }

  /* CODE MONSERUM — Sérum Vitamine C 15 ml (42 €) offert dès 120 € d'achat
     avec le code, du 18/08 au 23/08/2026 inclus, France uniquement.
     Le seuil client est volontairement conservateur : 120 € hors cadeau et
     hors échantillons — on n'ajoute jamais un cadeau que Shopify pourrait
     facturer. Porte de test : ?pers-code=1 / ?pers-code=0. */
  var CODE_NAME = 'MONSERUM';
  var CODE_T = 12000;
  var CODE_START = new Date('2026-08-18T00:00:00+02:00').getTime();
  var CODE_END = new Date('2026-08-24T00:00:00+02:00').getTime();
  var _codeGate = readGate('pers-code', 'persCode');
  function codeEnabled() { return windowOn(_codeGate, CODE_START, CODE_END); }

  /* PROMO RENTRÉE — -20 % sur la routine complète et les duos, du 29/08 au
     04/09/2026 inclus. La remise réelle est un discount automatique Shopify
     (« -20% Routines & Duos », non combinable) ; ici uniquement la couche
     d'AFFICHAGE : case visuelle dans la grille de /collections/routines-duos
     et prix remisés (prix barré = prix de vente actuel, décision Valentin
     25/08) sur les cartes et pages des 4 produits concernés. Le Coffret
     3 actifs et le Glow on the go sont EXCLUS. Porte : ?pers-rd=1 / 0. */
  var RD_START = new Date('2026-08-29T00:00:00+02:00').getTime();
  var RD_END = new Date('2026-09-05T00:00:00+02:00').getTime();
  var _rdGate = readGate('pers-rd', 'persRd');
  /* Contrairement aux autres portes, =1 (liens de démo partagés à l'équipe)
     n'outrepasse jamais la FIN de la fenêtre : un navigateur resté sur
     ?pers-rd=1 revient de lui-même à l'affichage normal le 05/09. */
  function rdEnabled() {
    if (_rdGate === '0') return false;
    var now = Date.now();
    if (_rdGate === '1') return now < RD_END;
    return now >= RD_START && now < RD_END;
  }
  var RD_PRODUCT_IDS = ['8422329221467', '9759328665947', '9759365726555', '10301835870555'];
  /* Carte promo injectée en tête des upsells du drawer pendant la fenêtre
     (le pool Liquid ne propose jamais routines/duos) : premier produit de
     cette liste absent du panier. Le protocole (381 €) volontairement en
     dernier. Prix en centimes EUR = REPLI seulement : la carte affiche le
     prix du .js produit (l'équipe a changé les tarifs entre la préparation
     et le lancement, un montant en dur ment dès que ça bouge). */
  var RD_UPSELL = [
    { id: '9759328665947', handle: 'duo-serum-haute-concentration', handleEn: 'duo-serum-high-concentration', variant: '50122346660187', title: 'Duo Sérums Haute Concentration', titleEn: 'High Concentration Serum Duo', price: 17500 },
    { id: '9759365726555', handle: 'duo-du-soir-haute-performance', handleEn: 'evening-duo', variant: '50122604642651', title: 'Duo du Soir Haute Performance', titleEn: 'High Performance Evening Duo', price: 18000 },
    { id: '10301835870555', handle: 'le-duo-nettoyant', handleEn: 'the-cleansing-duo', variant: '52096461373787', title: 'Le duo nettoyant', titleEn: 'The Cleansing Duo', price: 9000 },
    { id: '8422329221467', handle: 'protocole-complet', handleEn: 'complete-protocol', variant: '48153393070427', title: 'Le protocole complet', titleEn: 'Complete protocol', price: 38100 }
  ];
  function rdIsEn() {
    return (document.documentElement.lang || 'fr').toLowerCase().indexOf('en') === 0;
  }

  var routes = (window.theme && window.theme.routes) || {};
  var addUrl = routes.cartAdd || '/cart/add.js';
  var changeUrl = routes.cartChange || '/cart/change.js';
  var updateUrl = routes.cartChange ? routes.cartChange.replace('/change.js', '/update.js') : '/cart/update.js';

  var _currency = 'EUR';
  var _sampleInCartId = null;
  var _sampleLineKey = null;
  var _sampleQty = 0;
  var _sampleRemoving = false;
  var _sampleClamping = false;
  var _kitLineKey = null;
  var _kitQty = 0;
  var _kitClamping = false;
  var _gwpInCartKey = null;
  var _gwpRemoving = false;
  var _codeGiftKey = null;
  var _codeGiftRemoving = false;
  var _codeAutoAdding = false;
  var _codeApplying = false;

  function curConf(cur) {
    if (cur === 'GBP') return { symbol: '£', before: true, dec: '.' };
    return { symbol: '€', before: false, dec: ',' };
  }

  /* 29 € / £29 ; 12,50 € / £12.50 — espace insécable avant € */
  function fmtAmount(minor, conf) {
    var n = minor / 100;
    var s = (Math.round(n) === n) ? String(n) : n.toFixed(2).replace('.', conf.dec);
    return conf.before ? conf.symbol + s : s + ' ' + conf.symbol;
  }

  function getRoot() { return document.querySelector('[data-cart-rewards]'); }

  /* Écrit txt partout, avec garde anti-boucle (MutationObserver) */
  function setAll(root, sel, txt) {
    var els = root.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== txt) els[i].textContent = txt;
    }
  }

  function frCountry(cart) {
    var country = (cart.attributes && cart.attributes['Customer country']) || '';
    return country === '' || country === 'FR';
  }

  /* Badges de palier sur les cartes upsell (28/07/2026, validé Valentin) :
     signale les produits dont l'ajout suffit à débloquer le prochain
     avantage. Prix lu sur data-product-price (unités mineures) du bouton
     d'ajout ; cartes en rupture (pas de bouton) ignorées. Priorité : sérum
     MONSERUM (client déjà engagé par le code) > casquette > livraison. */
  function upsellBadge(price, ctx, en) {
    if (ctx.codeReady && ctx.codeRemaining > 0 && price >= ctx.codeRemaining) {
      return en ? 'Unlocks your free 15ml serum' : 'Débloque votre sérum 15 ml offert';
    }
    var gwpHit = ctx.gwpReady && ctx.gwpRemaining > 0 && price >= ctx.gwpRemaining;
    var shipHit = ctx.shipRemaining > 0 && price >= ctx.shipRemaining;
    if (gwpHit && shipHit) return en ? 'Unlocks shipping + free cap' : 'Débloque livraison + casquette';
    if (gwpHit) return en ? 'Unlocks the free cap' : 'Débloque la casquette offerte';
    if (shipHit) return en ? 'Unlocks free shipping' : 'Débloque la livraison offerte';
    return '';
  }

  /* Écritures gardées (MutationObserver sur #HeaderCart -> pas de boucle).
     ctx null = tout effacer (panier vide, marché US sans paliers).
     Règle d'affichage (itérée avec Valentin le 28/07) : le badge n'apparaît
     que s'il DISCRIMINE les cartes visibles. Près du palier, « ça débloque »
     est une info de panier, pas de carte : si toutes les cartes qualifient
     (ou aucune), marquer serait redondant ou trompeur -> aucun badge, la
     barre « Plus que X € » suffit. Si certaines qualifient et d'autres non,
     les qualifiantes sont marquées : l'implication « les autres ne
     débloquent rien » est alors vraie, c'est l'info utile. */
  function decorateUpsells(ctx) {
    var en = (document.documentElement.lang || 'fr').toLowerCase().indexOf('en') === 0;
    /* la carte promo rentrée (--rd) porte son propre badge -20 % : exclue
       du jeu des badges de palier (ni ajout, ni retrait) */
    var all = document.querySelectorAll('.cart-upsell-card');
    var cards = [];
    for (var k = 0; k < all.length; k++) {
      if (!all[k].classList.contains('cart-upsell-card--rd')) cards.push(all[k]);
    }
    var entries = [];
    var priced = 0, labeled = 0;
    var i, card;
    for (i = 0; i < cards.length; i++) {
      card = cards[i];
      var btn = card.querySelector('.cart-upsell-card__add-btn');
      var price = btn ? parseInt(btn.getAttribute('data-product-price'), 10) : NaN;
      var label = '';
      if (ctx && !isNaN(price)) {
        priced++;
        label = upsellBadge(price, ctx, en);
        if (label) labeled++;
      }
      entries.push(label);
    }
    var discriminant = labeled > 0 && labeled < priced;
    for (i = 0; i < cards.length; i++) {
      card = cards[i];
      var badge = card.querySelector('.cart-upsell-card__badge');
      if (discriminant && entries[i]) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-upsell-card__badge';
          var info = card.querySelector('.cart-upsell-card__info');
          if (info) info.appendChild(badge); else card.appendChild(badge);
        }
        if (badge.textContent !== entries[i]) badge.textContent = entries[i];
      } else if (badge) {
        badge.remove();
      }
    }
  }

  /* ===== PROMO RENTRÉE : carte upsell dédiée (le pool Liquid du thème ne
     propose jamais les routines/duos, un badge seul ne montrerait rien).
     Injectée en tête, plafond global de 3 cartes conservé ; l'ajout au
     panier passe par le bouton standard (délégation existante), et au
     re-rendu la carte bascule d'elle-même sur le produit remisé suivant. */
  var _rdUpsellItems = null;
  var _rdProdCache = {};
  function rdRemoveUpsellCard() {
    var el = document.querySelector('.cart-upsell-card--rd');
    if (el) el.remove();
  }
  function rdInjectUpsell() {
    /* prix de la carte en EUR en dur : pas de carte hors devise EUR (GBP/USD),
       le discount serveur s'applique de toute façon partout */
    if (!rdEnabled() || (_currency && _currency !== 'EUR')) {
      rdRemoveUpsellCard();
      return;
    }
    var container = document.querySelector('.cart-drawer-upsell__products');
    if (!container || !_rdUpsellItems) return;
    var inCart = {};
    for (var i = 0; i < _rdUpsellItems.length; i++) inCart[String(_rdUpsellItems[i].product_id)] = 1;
    var pick = null;
    for (i = 0; i < RD_UPSELL.length; i++) {
      if (!inCart[RD_UPSELL[i].id]) { pick = RD_UPSELL[i]; break; }
    }
    var existing = document.querySelector('.cart-upsell-card--rd');
    if (!pick) { rdRemoveUpsellCard(); return; }
    if (existing) {
      if (existing.getAttribute('data-product-id') === pick.id) return;
      existing.remove();
    }
    var en = rdIsEn();
    var url = en ? '/en/products/' + pick.handleEn : '/products/' + pick.handle;
    var title = en ? pick.titleEn : pick.title;
    var build = function (p) {
      if (!p || !p.available) return;
      if (document.querySelector('.cart-upsell-card--rd')) return;
      var cont = document.querySelector('.cart-drawer-upsell__products');
      if (!cont || !rdEnabled()) return;
      var conf = curConf('EUR');
      /* prix courant du .js produit (source vive), repli sur la constante */
      var base = (typeof p.price === 'number' && p.price > 0) ? p.price : pick.price;
      var card = document.createElement('div');
      card.className = 'cart-upsell-card cart-upsell-card--rd';
      card.setAttribute('data-product-id', pick.id);
      var img = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=240') : '';
      card.innerHTML =
        '<a href="' + url + '" class="cart-upsell-card__image-link">' +
          (img ? '<img src="' + img + '" alt="" width="240" height="320" class="cart-upsell-card__image">' : '') +
        '</a>' +
        '<div class="cart-upsell-card__info">' +
          '<a href="' + url + '" class="cart-upsell-card__title">' + title + '</a>' +
          '<div class="cart-upsell-card__price-row">' +
            '<span class="cart-upsell-card__price">' + fmtAmount(Math.round(base * 0.8), conf) +
              '<span class="cart-upsell-card__price-compare">' + fmtAmount(base, conf) + '</span></span>' +
            '<button type="button" class="cart-upsell-card__add-btn" data-variant-id="' + pick.variant + '"' +
              ' data-product-title="' + title + '" data-product-price="' + Math.round(base * 0.8) + '"' +
              ' aria-label="' + (en ? 'Add ' + title + ' to cart' : 'Ajouter ' + title + ' au panier') + '">' +
              '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
              '</svg>' +
            '</button>' +
          '</div>' +
          '<span class="cart-upsell-card__badge">' + (en ? '-20% until 4 September' : '-20% jusqu’au 4 septembre') + '</span>' +
        '</div>';
      var themeCards = cont.querySelectorAll('.cart-upsell-card:not(.cart-upsell-card--rd)');
      if (themeCards.length >= 3) themeCards[themeCards.length - 1].remove();
      cont.insertBefore(card, cont.firstChild);
    };
    if (_rdProdCache[url]) { build(_rdProdCache[url]); return; }
    fetch(url + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { _rdProdCache[url] = p; build(p); })
      .catch(function () {});
  }

  function update() {
    var root = getRoot();
    if (!root) return;

    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          root.hidden = true;
          decorateUpsells(null);
          return;
        }

        _currency = cart.currency || 'EUR';
        var conf = curConf(_currency);
        var sampleIds = (root.getAttribute('data-sample-variants') || '').split(',');
        var gwpEl = root.querySelector('[data-cr-gwp]');
        var gwpVariant = gwpEl ? gwpEl.getAttribute('data-cr-gwp-variant') : null;
        var codeEl = root.querySelector('[data-cr-code]');
        var codeVariant = codeEl ? codeEl.getAttribute('data-cr-code-variant') : null;

        /* eligible : seuils échantillon + livraison (tout sauf échantillons et
           cadeaux). gwpEligible : seuil casquette — exclut EN PLUS les lignes
           casquette payées, comme le prérequis du discount BXGY (sinon on
           proposerait un cadeau que Shopify facturerait). codeEligible : seuil
           MONSERUM — exclut de même toute ligne du sérum 15 ml. */
        var eligible = 0, gwpEligible = 0, codeEligible = 0;
        _sampleInCartId = null;
        _sampleLineKey = null;
        _sampleQty = 0;
        _kitLineKey = null;
        _kitQty = 0;
        _gwpInCartKey = null;
        _codeGiftKey = null;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          var vid = String(it.variant_id);
          var props = it.properties || {};
          if (vid === KIT_ID) { _kitLineKey = it.key; _kitQty += it.quantity; }
          if (sampleIds.indexOf(vid) !== -1) {
            _sampleInCartId = vid; // l'échantillon ne compte dans aucun seuil
            _sampleLineKey = it.key;
            _sampleQty += it.quantity;
          } else if (gwpVariant && vid === gwpVariant && (props._gwp === 'cap-you-glow' || it.final_line_price === 0)) {
            _gwpInCartKey = it.key; // la casquette offerte ne compte pas
          } else if (codeVariant && vid === codeVariant && (props._gwp === 'monserum' || it.final_line_price === 0)) {
            _codeGiftKey = it.key; // le sérum 15 ml offert ne compte pas
          } else {
            eligible += it.final_line_price;
            if (!(gwpVariant && vid === gwpVariant)) gwpEligible += it.final_line_price;
            if (!(codeVariant && vid === codeVariant)) codeEligible += it.final_line_price;
          }
        }

        /* Kit découverte : 1 max par panier, quelle que soit la devise. */
        if (_kitLineKey && _kitQty > 1) clampKit();

        /* Marché US (USD, 28/07/2026, demande Clara) : pas d'échantillons pour
           les États-Unis — et vérification faite le même jour, il n'y a AUCUNE
           livraison offerte en zone US (seul tarif : DHL Express ~46 $ même à
           210 $ de panier), la barre « Free shipping · $100 » y était une
           fausse promesse. Module entièrement masqué en USD, échantillon
           retiré du panier le cas échéant. */
        if (_currency === 'USD') {
          root.hidden = true;
          if (_sampleInCartId) removeSampleSilent();
          decorateUpsells(null);
          rdRemoveUpsellCard();
          return;
        }

        root.hidden = false;

        var badgeGwpReady = false, badgeGwpRemaining = 0;
        var badgeCodeReady = false, badgeCodeRemaining = 0;

        var shipT = shipThreshold(_currency);
        setAll(root, '[data-cr-remaining-sample]', fmtAmount(Math.max(SAMPLE_T - eligible, 0), conf));
        setAll(root, '[data-cr-remaining-ship]', fmtAmount(Math.max(shipT - eligible, 0), conf));
        setAll(root, '[data-cr-threshold-sample]', fmtAmount(SAMPLE_T, conf));
        setAll(root, '[data-cr-threshold-ship]', fmtAmount(shipT, conf));

        var fill = root.querySelector('[data-cr-fill]');
        if (fill) {
          var pct = Math.min(eligible / shipT * 100, 100) + '%';
          if (fill.style.width !== pct) fill.style.width = pct;
        }

        /* Repère échantillon : 29 % de l'échelle en EUR (29/100), 34 % en GBP (29/85) */
        var dot = root.querySelector('.cart-rewards__bar-dot--sample');
        if (dot) {
          var dotLeft = Math.round(SAMPLE_T / shipT * 100) + '%';
          if (dot.style.left !== dotLeft) dot.style.left = dotLeft;
        }

        /* ÉCHANTILLON — garde-fous (signalement Lucile 19/08/2026) :
           1 seul échantillon, quantité 1 ; s'il est au panier sous 29 € hors
           échantillon, il est retiré automatiquement (comme la casquette et le
           15 ml) au lieu du simple avertissement — sinon une commande composée
           d'échantillons seuls passait au checkout. La vraie garde est côté
           serveur (échantillons à 5 € + discount automatique « Échantillon
           offert dès 29 € », 1 par commande) ; ici on évite juste l'affichage
           d'un état incohérent. */
        if (_sampleInCartId && eligible < SAMPLE_T) {
          removeSampleSilent();
          _sampleInCartId = null;
        } else if (_sampleInCartId && _sampleQty > 1) {
          clampSample();
        }

        var state;
        if (_sampleInCartId) state = 'added';
        else state = (eligible >= SAMPLE_T) ? 'choose' : 'progress';
        if (root.getAttribute('data-state') !== state) root.setAttribute('data-state', state);

        var ship = (eligible >= shipT) ? 'done' : 'progress';
        if (root.getAttribute('data-ship') !== ship) root.setAttribute('data-ship', ship);

        /* GWP CASQUETTE : retrait automatique si le cadeau est au panier sans
           y avoir droit (sous 80 € hors casquette, hors fenêtre, hors France) —
           sans le discount il serait facturé 25 €. Ne touche jamais une
           casquette payée (détection par propriété _gwp / prix à 0). */
        if (gwpEl) {
          var gwpOn = gwpEnabled() &&
            gwpEl.getAttribute('data-cr-gwp-available') === '1' &&
            _currency === 'EUR' && frCountry(cart);
          var gwpActive = gwpOn ? '1' : '0';
          if (root.getAttribute('data-gwp-active') !== gwpActive) root.setAttribute('data-gwp-active', gwpActive);
          badgeGwpReady = gwpOn && !_gwpInCartKey;
          badgeGwpRemaining = Math.max(GWP_T - gwpEligible, 0);
          setAll(root, '[data-cr-remaining-gwp]', fmtAmount(Math.max(GWP_T - gwpEligible, 0), conf));
          var gwpState;
          if (!gwpOn) {
            gwpState = 'off';
            if (_gwpInCartKey) removeGwp();
          } else if (_gwpInCartKey) {
            gwpState = (gwpEligible >= GWP_T) ? 'added' : 'progress';
            if (gwpEligible < GWP_T) removeGwp();
          } else {
            gwpState = (gwpEligible >= GWP_T) ? 'choose' : 'progress';
          }
          if (gwpEl.getAttribute('data-gwp-state') !== gwpState) gwpEl.setAttribute('data-gwp-state', gwpState);
        }

        /* CODE MONSERUM : le code est porté par le panier côté serveur
           (cart.discount_codes). Une fois saisi, le cadeau s'ajoute tout seul
           dès 120 € hors cadeau, et se retire si le panier redescend (sans le
           discount il serait facturé 42 €). Un sérum 15 ml payé (prix > 0,
           sans propriété _gwp) n'est jamais touché. */
        if (codeEl) {
          var codeOn = codeEnabled() && _currency === 'EUR' && frCountry(cart);
          var codeApplied = false;
          var codes = cart.discount_codes || [];
          for (var c = 0; c < codes.length; c++) {
            if (String(codes[c].code || '').toUpperCase() === CODE_NAME) codeApplied = true;
          }
          setAll(root, '[data-cr-remaining-code]', fmtAmount(Math.max(CODE_T - codeEligible, 0), conf));
          badgeCodeReady = codeOn && codeApplied && !_codeGiftKey;
          badgeCodeRemaining = Math.max(CODE_T - codeEligible, 0);
          var codeState;
          if (!codeOn) {
            codeState = 'off';
            if (_codeGiftKey) removeCodeGift();
          } else if (_codeGiftKey) {
            /* Cadeau présent : on ne le retire que si le panier hors cadeau
               repasse sous le seuil (le discount ne le couvrirait plus). */
            codeState = 'applied';
            if (codeEligible < CODE_T) removeCodeGift();
          } else if (codeApplied) {
            if (codeEligible >= CODE_T && codeEl.getAttribute('data-cr-code-available') === '1') {
              codeState = 'undermin'; /* transitoire, le temps de l'ajout */
              autoAddCodeGift(codeEl);
            } else {
              codeState = 'undermin';
            }
          } else {
            codeState = 'field';
          }
          if (codeEl.getAttribute('data-code-state') !== codeState) codeEl.setAttribute('data-code-state', codeState);
        }

        decorateUpsells({
          shipRemaining: Math.max(shipT - eligible, 0),
          gwpReady: badgeGwpReady,
          gwpRemaining: badgeGwpRemaining,
          codeReady: badgeCodeReady,
          codeRemaining: badgeCodeRemaining
        });

        _rdUpsellItems = cart.items;
        rdInjectUpsell();
        /* le thème re-rend la section upsell juste après l'événement panier */
        setTimeout(rdInjectUpsell, 900);
      })
      .catch(function () { /* silencieux */ });
  }

  function addSample(btn) {
    if (btn.classList.contains('is-loading')) return;
    if (_sampleInCartId) return; // un seul échantillon
    btn.classList.add('is-loading');

    var variantId = btn.getAttribute('data-cr-add');

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1, properties: {
          '_source': 'cart_rewards'
        } }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.classList.remove('is-loading');
        if (!data || data.status === 422 || data.status === 'bad_request' || !data.items || data.items.length === 0) {
          /* 09/10/2026 : refus Shopify = échantillon épuisé entre le rendu de la page et le clic
             (vente en rupture désactivée) : on retire la carte et on le dit, au lieu de ne rien faire */
          sampleSoldOut(btn);
          return;
        }
        trackEvent('cart_rewards_sample_add', variantId);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { variant_id: variantId, product: data, from_upsell: true }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  }

  function sampleSoldOut(btn) {
    var root = document.querySelector('[data-cart-rewards]');
    var en = (document.documentElement.lang || 'fr').toLowerCase().indexOf('en') === 0;
    btn.hidden = true;
    var left = root ? root.querySelectorAll('[data-cr-add]:not([hidden])').length : 0;
    var msg = root && root.querySelector('[data-cr-msg="choose"]');
    if (msg) {
      msg.textContent = left
        ? (en ? 'That sample is out of stock, pick another one:' : 'Cet échantillon est épuisé, choisissez-en un autre\u00a0:')
        : (en ? 'Our samples are temporarily out of stock.' : 'Nos échantillons sont momentanément épuisés.');
    }
  }

  function removeSample(btn) {
    if (btn.classList.contains('is-loading')) return;
    if (!_sampleInCartId) return;
    btn.classList.add('is-loading');

    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: _sampleInCartId, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.classList.remove('is-loading');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { from_upsell: true, product: cart }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  }

  /* Retrait silencieux de l'échantillon (marché US, ou panier repassé sous 29 €) */
  function removeSampleSilent() {
    if (_sampleRemoving || !_sampleInCartId) return;
    _sampleRemoving = true;
    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: _sampleLineKey || _sampleInCartId, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _sampleRemoving = false;
        _sampleInCartId = null;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { from_upsell: true, product: cart }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { _sampleRemoving = false; });
  }

  /* Quantité d'échantillon ramenée à 1 (le +/− de la ligne est masqué en CSS,
     mais le champ reste saisissable et /cart n'a pas cette protection). */
  function clampSample() {
    if (_sampleClamping || !_sampleLineKey) return;
    _sampleClamping = true;
    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: _sampleLineKey, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _sampleClamping = false;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { from_upsell: true, product: cart }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { _sampleClamping = false; });
  }

  /* Même clamp pour le Kit découverte (gratuit voulu, 1 max par panier). */
  function clampKit() {
    if (_kitClamping || !_kitLineKey) return;
    _kitClamping = true;
    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: _kitLineKey, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _kitClamping = false;
        _kitQty = 1;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { from_upsell: true, product: cart }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { _kitClamping = false; });
  }

  function addGwp(btn) {
    if (btn.classList.contains('is-loading')) return;
    if (_gwpInCartKey) return; // un seul cadeau par commande
    btn.classList.add('is-loading');

    var variantId = btn.getAttribute('data-cr-gwp-add');

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1, properties: {
          '_source': 'cart_rewards',
          '_gwp': 'cap-you-glow'
        } }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.classList.remove('is-loading');
        if (!data || data.status === 422 || data.status === 'bad_request' || !data.items || data.items.length === 0) {
          /* rupture de stock (policy deny) : on masque l'offre */
          var root = getRoot();
          var el = root && root.querySelector('[data-cr-gwp]');
          if (el) el.setAttribute('data-cr-gwp-available', '0');
          update();
          return;
        }
        trackEvent('cart_rewards_gwp_add', variantId);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { variant_id: variantId, product: data, from_upsell: true }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  }

  function removeGwp() {
    if (_gwpRemoving || !_gwpInCartKey) return;
    _gwpRemoving = true;
    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: _gwpInCartKey, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _gwpRemoving = false;
        _gwpInCartKey = null;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { from_upsell: true, product: cart }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { _gwpRemoving = false; });
  }

  /* Saisie du code dans le drawer : application côté serveur par l'API panier
     (POST /cart/update.js { discount }) — le code suit ensuite le panier
     jusqu'au checkout. MONSERUM est géré par la machine à états d'update() ;
     tout autre code valide est simplement appliqué. */
  function applyCode(btn) {
    if (_codeApplying) return;
    var root = getRoot();
    var codeEl = root && root.querySelector('[data-cr-code]');
    var input = codeEl && codeEl.querySelector('[data-cr-code-input]');
    if (!input) return;
    var code = (input.value || '').trim().toUpperCase();
    if (!code) return;
    _codeApplying = true;
    if (btn) btn.classList.add('is-loading');

    fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _codeApplying = false;
        if (btn) btn.classList.remove('is-loading');
        var entry = null;
        var codes = (cart && cart.discount_codes) || [];
        for (var i = 0; i < codes.length; i++) {
          if (String(codes[i].code || '').toUpperCase() === code) entry = codes[i];
        }
        var fb = codeEl.querySelector('[data-cr-code-feedback]');
        if (code === CODE_NAME) {
          /* la machine à états prend le relais (ajout auto ou message seuil) */
          if (fb) fb.textContent = '';
          trackEvent('cart_rewards_code_apply', code);
          update();
        } else if (entry && entry.applicable) {
          if (fb) fb.textContent = codeEl.getAttribute('data-msg-applied') || '';
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { from_upsell: true, product: cart }
          }));
          update();
        } else {
          if (fb) fb.textContent = codeEl.getAttribute('data-msg-invalid') || '';
        }
      })
      .catch(function () {
        _codeApplying = false;
        if (btn) btn.classList.remove('is-loading');
      });
  }

  function autoAddCodeGift(codeEl) {
    if (_codeAutoAdding || _codeGiftKey) return;
    _codeAutoAdding = true;
    var variantId = codeEl.getAttribute('data-cr-code-variant');

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1, properties: {
          '_source': 'cart_rewards',
          '_gwp': 'monserum'
        } }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        _codeAutoAdding = false;
        if (!data || data.status === 422 || data.status === 'bad_request' || !data.items || data.items.length === 0) {
          /* rupture de stock : on fige le champ en l'état, sans réessayer */
          codeEl.setAttribute('data-cr-code-available', '0');
          update();
          return;
        }
        trackEvent('cart_rewards_code_gift_add', variantId);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { variant_id: variantId, product: data, from_upsell: true }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { _codeAutoAdding = false; });
  }

  function removeCodeGift() {
    if (_codeGiftRemoving || !_codeGiftKey) return;
    _codeGiftRemoving = true;
    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: _codeGiftKey, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _codeGiftRemoving = false;
        _codeGiftKey = null;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { from_upsell: true, product: cart }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { _codeGiftRemoving = false; });
  }

  /* Tracking best-effort (cadeaux à 0 € : la valeur est dans l'événement dédié) */
  function trackEvent(name, value) {
    try {
      if (typeof gtag !== 'undefined') {
        gtag('event', name, { variant_id: String(value), currency: _currency });
      }
      if (window.dataLayer) {
        window.dataLayer.push({ event: name, variant_id: String(value), currencyCode: _currency });
      }
    } catch (e) { /* silencieux */ }
  }

  /* Délégation : les boutons sont re-rendus avec le drawer */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-cr-add]');
    if (addBtn) { e.preventDefault(); e.stopPropagation(); addSample(addBtn); return; }
    var removeBtn = e.target.closest('[data-cr-remove]');
    if (removeBtn) { e.preventDefault(); e.stopPropagation(); removeSample(removeBtn); return; }
    var gwpBtn = e.target.closest('[data-cr-gwp-add]');
    if (gwpBtn) { e.preventDefault(); e.stopPropagation(); addGwp(gwpBtn); return; }
    var codeBtn = e.target.closest('[data-cr-code-apply]');
    if (codeBtn) { e.preventDefault(); e.stopPropagation(); applyCode(codeBtn); return; }
  });

  /* Entrée dans le champ code : appliquer, sans soumettre le formulaire panier
     qui enveloppe tout le drawer (le champ n'a pas de <form> propre). */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-cr-code-input]');
    if (!input) return;
    e.preventDefault();
    e.stopPropagation();
    var codeEl = input.closest('[data-cr-code]');
    var btn = codeEl && codeEl.querySelector('[data-cr-code-apply]');
    applyCode(btn);
  });

  document.addEventListener('ajaxProduct:added', function () { setTimeout(update, 300); });
  document.addEventListener('CartDrawer:open', function () { update(); });

  /* Le thème remplace le contenu du drawer à chaque changement panier :
     réévaluation débouncée à la moindre mutation. Écritures gardées -> pas de boucle. */
  var hc = document.getElementById('HeaderCart');
  if (hc) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(update, 150);
    }).observe(hc, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') update();
  else document.addEventListener('DOMContentLoaded', update);

  /* ===== GARDE PAGE /cart (19/08/2026) =====
     Le module Cart Rewards n'est pas rendu sur /cart, mais la page a les mêmes
     lignes (.cart__item[data-key] + input updates[]) et son bouton « Procéder au
     paiement » soumet le formulaire AVEC les quantités saisies : on pouvait y
     taper 25 échantillons puis payer, ou retirer le produit et partir au
     checkout avec l'échantillon seul (commandes #11894/#11895 du 11/08).
     Ici : (1) au chargement, quantité ramenée à 1 / échantillon retiré sous
     29 € hors échantillon ; (2) à la soumission, recalcul avec les quantités
     saisies puis forçage des champs échantillon (1 ou 0) avant l'envoi. */
  var SAMPLE_FALLBACK_IDS = ['48301185958235', '48301191823707', '54154730504539'];
  var PAGE_FORM_SEL = 'form[action*="/cart"][data-location="page"]';
  function cartPageGuard() {
    if (!/\/cart\/?$/.test(location.pathname)) return;
    if (!document.querySelector(PAGE_FORM_SEL)) return;
    var root = getRoot();
    var ids = root ? (root.getAttribute('data-sample-variants') || '').split(',') : SAMPLE_FALLBACK_IDS;
    function isSampleKey(key) {
      for (var i = 0; i < ids.length; i++) if (key.indexOf(ids[i] + ':') === 0) return true;
      return false;
    }
    function isKitKey(key) { return key.indexOf(KIT_ID + ':') === 0; }
    function post(op) {
      return fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(op)
      });
    }
    function getCart() {
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); });
    }
    /* (1) chargement */
    getCart().then(function (cart) {
      var eligible = 0, samples = [], kits = [];
      cart.items.forEach(function (it) {
        if (isSampleKey(it.key)) { samples.push(it); return; }
        if (isKitKey(it.key)) kits.push(it);
        eligible += it.final_line_price;
      });
      var ops = [];
      samples.forEach(function (it) {
        if (eligible < SAMPLE_T) ops.push({ id: it.key, quantity: 0 });
        else if (it.quantity > 1) ops.push({ id: it.key, quantity: 1 });
      });
      /* Kit découverte : ramené à 1, jamais retiré (achat seul légitime). */
      kits.forEach(function (it) {
        if (it.quantity > 1) ops.push({ id: it.key, quantity: 1 });
      });
      if (!ops.length) return;
      var last = 0;
      try { last = parseInt(sessionStorage.getItem('persCartGuardReload') || '0', 10); } catch (e) {}
      if (Date.now() - last < 10000) return; // pas de boucle de rechargement
      var p = Promise.resolve();
      ops.forEach(function (op) { p = p.then(function () { return post(op); }); });
      p.then(function () {
        try { sessionStorage.setItem('persCartGuardReload', String(Date.now())); } catch (e) {}
        location.reload();
      }).catch(function () {});
    }).catch(function () {});
    /* (2) soumission — le bouton « Procéder au paiement » du thème soumet
       le formulaire par script (form.submit(), aucun événement submit), donc
       interception du CLIC (capture, niveau document : le thème re-rend le
       formulaire) + de l'événement submit (touche Entrée). */
    function fixInputs(form) {
      var inputs = form.querySelectorAll('.js-qty__num[data-id]');
      return getCart().then(function (cart) {
        var eligible = 0, sampleInputs = [];
        cart.items.forEach(function (it) {
          if (isSampleKey(it.key)) return;
          var qty = it.quantity;
          for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].getAttribute('data-id') === it.key) { var v = parseInt(inputs[i].value, 10); if (!isNaN(v)) qty = v; }
          }
          eligible += it.price * qty;
        });
        for (var j = 0; j < inputs.length; j++) {
          var key = inputs[j].getAttribute('data-id') || '';
          if (isSampleKey(key)) sampleInputs.push(inputs[j]);
          else if (isKitKey(key)) {
            var kv = parseInt(inputs[j].value, 10);
            if (!isNaN(kv) && kv > 1) inputs[j].value = '1';
          }
        }
        sampleInputs.forEach(function (inp) {
          var want = (eligible < SAMPLE_T) ? '0' : '1';
          if (inp.value !== want) inp.value = want;
        });
      }).catch(function () {});
    }
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button[name="checkout"], input[name="checkout"]') : null;
      if (!btn) return;
      var form = btn.closest(PAGE_FORM_SEL);
      if (!form) return;
      if (form.getAttribute('data-cr-guarded') === '1') { form.removeAttribute('data-cr-guarded'); return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      fixInputs(form).then(function () {
        form.setAttribute('data-cr-guarded', '1');
        btn.click();
      });
    }, true);
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches(PAGE_FORM_SEL)) return;
      if (form.getAttribute('data-cr-guarded') === '1') { form.removeAttribute('data-cr-guarded'); return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      var submitter = e.submitter || null;
      fixInputs(form).then(function () {
        form.setAttribute('data-cr-guarded', '1');
        if (typeof form.requestSubmit === 'function') {
          if (submitter && form.contains(submitter)) form.requestSubmit(submitter); else form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }, true);
  }
  if (document.readyState !== 'loading') cartPageGuard();
  else document.addEventListener('DOMContentLoaded', cartPageGuard);

  /* ===== PAGE PRODUIT DU KIT DÉCOUVERTE (25/08/2026) =====
     Le sélecteur de quantité du formulaire principal permettait d'ajouter le
     kit en plusieurs exemplaires (le drawer rattrapait ensuite, mais l'UI ne
     doit pas le proposer) : bloc quantité masqué, champ ramené à 1, et
     quantité forcée à 1 à la soumission par sécurité. La barre sticky ajoute
     déjà toujours 1 (formulaire sans champ quantité). */
  function kitProductGuard() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    var sel = document.querySelector('select[name="id"][data-product-select]');
    var isKit = false;
    if (sel) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === KIT_ID) { isKit = true; break; }
      }
    }
    if (!isKit) return;
    var qty = document.querySelector('.js-qty__num[name="quantity"]');
    if (qty) {
      qty.value = '1';
      var block = qty.closest('.product__quantity');
      if (block) block.style.display = 'none';
    }
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      var q = form.querySelector('input[name="quantity"]') ||
        (form.id ? document.querySelector('input[name="quantity"][form="' + form.id + '"]') : null);
      if (q && q.value !== '1') q.value = '1';
    }, true);
  }
  if (document.readyState !== 'loading') kitProductGuard();
  else document.addEventListener('DOMContentLoaded', kitProductGuard);

  /* ===== PROMO RENTRÉE : couche d'affichage (voir constantes RD_* plus haut).
     Les prix sont réécrits à partir du texte affiché (×0,8, même format et
     même devise), jamais recalculés depuis une valeur en dur : le serveur
     (discount automatique) reste la seule source de vérité au paiement. */
  function rdDiscounted(txt) {
    var m = txt.match(/(\d+(?:[.,]\d+)?)/);
    if (!m) return null;
    var val = parseFloat(m[1].replace(',', '.'));
    if (!isFinite(val) || val <= 0) return null;
    var sep = m[1].indexOf(',') !== -1 ? ',' :
      (m[1].indexOf('.') !== -1 ? '.' :
        ((document.documentElement.lang || 'fr').indexOf('en') === 0 ? '.' : ','));
    var d = Math.round(val * 80) / 100;
    var out = (d % 1 === 0) ? String(d) : d.toFixed(2).replace('.', sep);
    return txt.replace(m[1], out);
  }

  /* Cartes produit (collection, home, méga-menu) : prix remisé + prix de
     vente actuel barré à la place du compare-at existant. Deux markups :
     produit avec compare_at → le thème rend .price-sale/.price-compare-at ;
     sans compare_at → prix nu en texte dans .price (cas depuis le 29/08,
     l'équipe a aligné les prix sur l'ancien barré pour la promo) → on
     recrée la structure native de vente dans la div. */
  function rdDecorateCards() {
    var cards = document.querySelectorAll('.grid-item.grid-product[data-product-id]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (RD_PRODUCT_IDS.indexOf(card.getAttribute('data-product-id')) === -1) continue;
      var sale = card.querySelector('.price-sale');
      if (sale) {
        if (sale.getAttribute('data-rd') === '1') continue;
        var original = sale.textContent.trim();
        var reduced = rdDiscounted(original);
        if (!reduced) continue;
        sale.setAttribute('data-rd', '1');
        sale.textContent = reduced;
        var comp = card.querySelector('.price-compare-at');
        if (!comp) {
          comp = document.createElement('span');
          comp.className = 'price-compare-at';
          sale.parentNode.appendChild(comp);
        }
        comp.textContent = original;
        continue;
      }
      var priceDiv = card.querySelector('.price');
      if (!priceDiv || priceDiv.getAttribute('data-rd') === '1') continue;
      var plain = priceDiv.textContent.trim();
      /* uniquement un prix simple (« 175€ ») — jamais un « À partir de … » */
      if (plain.length > 14 || /[A-Za-z]/.test(plain)) continue;
      var cut = rdDiscounted(plain);
      if (!cut) continue;
      priceDiv.setAttribute('data-rd', '1');
      priceDiv.textContent = '';
      var s = document.createElement('span');
      s.className = 'price-sale';
      s.setAttribute('data-rd', '1');
      s.textContent = cut;
      var c = document.createElement('span');
      c.className = 'price-compare-at';
      c.textContent = plain;
      priceDiv.appendChild(s);
      priceDiv.appendChild(document.createTextNode(' '));
      priceDiv.appendChild(c);
    }
  }

  /* Page produit : prix principal remisé, prix actuel barré, mention -20 %. */
  function rdDecorateProduct() {
    var section = document.querySelector('.product-section[data-product-id]');
    if (!section || RD_PRODUCT_IDS.indexOf(section.getAttribute('data-product-id')) === -1) return;
    var priceEl = section.querySelector('[data-product-price]');
    if (!priceEl || priceEl.getAttribute('data-rd') === '1') return;
    var visible = priceEl.querySelector('[aria-hidden]');
    var original = (visible || priceEl).textContent.trim();
    var reduced = rdDiscounted(original);
    if (!reduced) return;
    priceEl.setAttribute('data-rd', '1');
    var spans = priceEl.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) spans[i].textContent = reduced;
    priceEl.classList.add('on-sale');
    var comp = section.querySelector('[data-compare-price]');
    if (!comp) {
      /* le thème ne rend le bloc compare que si compare_at > prix : absent
         depuis que l'équipe a aligné les prix (29/08) → on recrée le span
         natif (mêmes classes), placé AVANT le prix comme dans le template */
      comp = document.createElement('span');
      comp.setAttribute('data-compare-price', '');
      comp.className = 'product__price product__price--compare';
      comp.innerHTML = '<span aria-hidden="true"></span> <span class="visually-hidden"></span>';
      priceEl.parentNode.insertBefore(comp, priceEl);
    }
    var cSpans = comp.querySelectorAll('span');
    for (var j = 0; j < cSpans.length; j++) cSpans[j].textContent = original;
    comp.classList.remove('hide');
    var save = section.querySelector('[data-save-price]');
    if (save) {
      var en = (document.documentElement.lang || 'fr').indexOf('en') === 0;
      save.textContent = en ? 'Save 20% · Until September 4' : 'Économisez 20% · Jusqu’au 4 septembre';
      save.classList.remove('hide');
    }
  }

  /* Case visuelle dans la grille de la collection routines & duos, FR et EN
     (le chemin EN est /en/collections/routines-bundles via langify). Visuels
     hébergés dans Contenu > Fichiers de l'admin (v3 = visuels feed 1080×1350 servis en 1000 px, uploadés le 01/09). */
  function rdInjectTile() {
    if (!/^\/(en\/)?collections\/(routines-duos|routines-bundles)\/?$/.test(location.pathname)) return;
    var grid = document.querySelector('.new-grid.product-grid.collection-grid');
    if (!grid || grid.querySelector('.rd-promo-tile')) return;
    var en = rdIsEn();
    var imgUrl = en ? '/cdn/shop/files/promo-rentree-v3-en.jpg' : '/cdn/shop/files/promo-rentree-v3.jpg';
    var tile = document.createElement('div');
    /* mêmes classes internes que les cartes produit : la case hérite du cadre
       image du thème (ratio 325:428, overflow hidden, img en cover) et reste
       alignée au pixel près quelle que soit la largeur d'écran */
    tile.className = 'grid-item grid-product grid-product-image-breathing-room--true rd-promo-tile';
    var img = document.createElement('img');
    img.src = imgUrl;
    img.alt = en ? 'Routines & bundles: 20% off until 4 September only'
      : 'Routines et duos à -20 %, jusqu’au 4 septembre seulement';
    /* PAS de loading=lazy : injecté après coup, le navigateur ne déclenchait
       jamais le fetch (constaté le 25/08) — et c'est le contenu de la case */
    var ic = document.createElement('div');
    ic.className = 'image-container';
    ic.appendChild(img);
    var pcc = document.createElement('div');
    pcc.className = 'product-card-content';
    pcc.appendChild(ic);
    var pc = document.createElement('div');
    pc.className = 'product-card-container';
    pc.appendChild(pcc);
    tile.appendChild(pc);
    var kids = grid.children;
    if (kids.length >= 3) grid.insertBefore(tile, kids[2]);
    else grid.appendChild(tile);
    rdSyncTile();
    /* les boîtes image des cartes sont retaillées par le thème pendant le
       chargement : on re-synchronise après coup et à chaque variation */
    setTimeout(rdSyncTile, 1200);
    setTimeout(rdSyncTile, 3500);
    var ref = document.querySelector('.grid-item.grid-product:not(.rd-promo-tile) .image-container');
    if (ref && window.ResizeObserver && !_rdTileRo) {
      _rdTileRo = new ResizeObserver(rdSyncTile);
      _rdTileRo.observe(ref);
    }
    window.addEventListener('resize', rdSyncTile);
  }

  /* La fenêtre image des cartes est dimensionnée dynamiquement par le thème
     (CSS cross-origin illisible, valeurs mouvantes au chargement) : la case
     copie la largeur ET la hauteur MESURÉES sur une carte voisine. La hauteur
     est copiée explicitement (et pas déduite d'aspect-ratio) : les Safari
     d'avant iOS 15 ignorent aspect-ratio, la case prenait alors la hauteur
     naturelle du visuel et cassait la rangée (constaté le 25/08 sur le
     téléphone de S-L, grille mobile avec une colonne vide). */
  var _rdTileRo = null;
  function rdSyncTile() {
    var tile = document.querySelector('.rd-promo-tile');
    if (!tile) return;
    var ic = tile.querySelector('.image-container');
    if (!ic) return;
    /* mobile : la case est en rangée pleine largeur (CSS), aucune copie de
       dimensions — on efface d'éventuels styles inline posés avant rotation */
    if (window.innerWidth <= 768) {
      if (ic.style.width) { ic.style.width = ''; ic.style.height = ''; ic.style.margin = ''; }
      return;
    }
    var ref = document.querySelector('.grid-item.grid-product:not(.rd-promo-tile) .image-container');
    if (!ref) return;
    var r = ref.getBoundingClientRect();
    if (r.width < 50 || r.height < 50) return;
    var w = Math.round(r.width) + 'px';
    var h = Math.round(r.height) + 'px';
    if (ic.style.width !== w || ic.style.height !== h) {
      ic.style.width = w;
      ic.style.height = h;
      ic.style.margin = '0 auto';
    }
  }

  /* Si le thème re-rend la grille (changement de vue, tri, AJAX), la case
     injectée disparaît avec l'ancien DOM : on ré-injecte, débouncé. Les
     fonctions sont idempotentes (gardes data-rd / carte déjà présente),
     donc pas de boucle avec l'observer. */
  var _rdGridMo = null;
  var _rdGridMoT = null;
  function rdObserveGrid() {
    var grid = document.querySelector('.new-grid.product-grid.collection-grid');
    if (!grid || !grid.parentNode || !window.MutationObserver || _rdGridMo) return;
    _rdGridMo = new MutationObserver(function () {
      if (_rdGridMoT) return;
      _rdGridMoT = setTimeout(function () {
        _rdGridMoT = null;
        rdInjectTile();
        rdDecorateCards();
        rdSyncTile();
      }, 300);
    });
    _rdGridMo.observe(grid.parentNode, { childList: true, subtree: true });
  }

  /* Widget « Options d'achat » du protocole (seul produit promo avec des
     plans d'abonnement) : UI custom .pers-purchase-widget du thème qui pilote
     l'app Avada Subscription (le bloc Avada natif est masqué). Sans ceci, le
     client lit le plein tarif juste au-dessus du bouton d'ajout alors que le
     haut de page annonce -20 %. On remise UNIQUEMENT l'achat unique : le
     -20 % ne s'applique pas aux abonnements (appliesOnSubscription: false).
     Le script du widget réécrit le « Prix total » à chaque changement de
     sélection → gardes par VALEUR ÉCRITE (pas un simple drapeau) : si le
     texte relu diffère de ce qu'on a écrit, le widget est repassé derrière
     nous et on réapplique depuis le texte courant. */
  function rdPurchaseWidget() {
    if (!rdEnabled()) return;
    var section = document.querySelector('.product-section[data-product-id]');
    if (!section || RD_PRODUCT_IDS.indexOf(section.getAttribute('data-product-id')) === -1) return;
    var w = document.querySelector('.pers-purchase-widget');
    if (!w) return;
    var once = w.querySelector('.pers-price--once');
    if (once) {
      var txt = once.textContent.trim();
      if (once.getAttribute('data-rd-val') !== txt) {
        var red = rdDiscounted(txt);
        if (red) {
          once.textContent = red;
          once.setAttribute('data-rd-val', red);
          var row = once.closest('.pers-option--once') || once.parentNode;
          if (!row.querySelector('.pers-price--original')) {
            var comp = document.createElement('span');
            comp.className = 'pers-price pers-price--original';
            comp.textContent = txt;
            once.parentNode.appendChild(comp);
          }
        }
      }
    }
    var sum = document.querySelector('.pers-price-summary');
    if (sum) {
      if (w.querySelector('.pers-option--once.selected')) {
        var st = sum.textContent;
        if (sum.getAttribute('data-rd-val') !== st) {
          var sred = rdDiscounted(st);
          if (sred) {
            sum.textContent = sred;
            sum.setAttribute('data-rd-val', sred);
          }
        }
      } else {
        /* mode abonnement : le total du widget est le bon, on n'y touche pas */
        sum.removeAttribute('data-rd-val');
      }
    }
  }

  var _rdPwMo = null;
  var _rdPwMoT = null;
  function rdObservePurchaseWidget() {
    var w = document.querySelector('.pers-purchase-widget');
    if (!w || !w.parentNode || !window.MutationObserver || _rdPwMo) return;
    _rdPwMo = new MutationObserver(function () {
      if (_rdPwMoT) return;
      _rdPwMoT = setTimeout(function () {
        _rdPwMoT = null;
        rdPurchaseWidget(); /* idempotent : nos propres écritures ne relancent rien */
      }, 200);
    });
    _rdPwMo.observe(w.parentNode, { childList: true, subtree: true, characterData: true });
  }

  function rdInit() {
    if (!rdEnabled()) return;
    rdInjectTile();
    rdDecorateCards();
    rdDecorateProduct();
    rdObserveGrid();
    /* certaines cartes (recommandations, méga-menu) sont rendues après coup,
       et le widget d'achat du protocole est construit par script (tardif) */
    setTimeout(rdDecorateCards, 1500);
    setTimeout(rdDecorateCards, 4000);
    setTimeout(rdInjectTile, 1500);
    setTimeout(rdInjectTile, 4000);
    rdPurchaseWidget();
    rdObservePurchaseWidget();
    [1500, 4000, 8000].forEach(function (t) {
      setTimeout(function () { rdPurchaseWidget(); rdObservePurchaseWidget(); }, t);
    });
  }
  if (document.readyState !== 'loading') rdInit();
  else document.addEventListener('DOMContentLoaded', rdInit);
})();

/*============================================================================
  Filet de sécurité lazyload (23/07) — images produit invisibles sur iOS.
  Le thème ne révèle une image (.lazyload, opacity 0) qu'après sa bascule en
  .lazyloaded par un IntersectionObserver posé sur <image-element>, or ce
  custom element mesure 0×0 (inline, aucun CSS ne lui donne de boîte) :
  Safari iOS ne le considère jamais comme intersectant et la bascule n'a
  jamais lieu (Chrome, lui, traite les cibles 0×0 comme intersectantes).
  On observe donc les <img> elles-mêmes (vraie boîte), même marge que le
  thème, et on fait la même bascule de classes.
==============================================================================*/
(function () {
  function reveal(img) {
    img.classList.remove('lazyload');
    img.classList.add('lazyloaded');
  }

  if (!('IntersectionObserver' in window)) {
    var flipAll = function () {
      document.querySelectorAll('img.lazyload').forEach(reveal);
    };
    if (document.readyState !== 'loading') flipAll();
    else document.addEventListener('DOMContentLoaded', flipAll);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        reveal(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px 400px 0px' });

  function scan() {
    document.querySelectorAll('img.lazyload').forEach(function (img) {
      io.observe(img); /* ré-observer une cible déjà suivie est un no-op */
    });
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  /* Contenu injecté après coup (drawer reconstruit, sections dynamiques) */
  var scanT;
  new MutationObserver(function () {
    clearTimeout(scanT);
    scanT = setTimeout(scan, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/*============================================================================
  Fond flouté derrière le drawer, desktop (22/09/2026)
  ----------------------------------------------------------------------------
  Voile .pers-cart-backdrop (CSS : fond sombre léger + backdrop-filter blur)
  inséré dans <body> et affiché tant que #HeaderCart porte .is-active (même
  signal que watchDrawerState). Clic sur le voile ou touche Échap = fermeture
  NATIVE (.js-close-header-cart) pour que l'en-tête se réinitialise aussi.
  Desktop seulement (>= 1024, comme le déplacement du drawer dans body).
  ACTIF PAR DÉFAUT depuis le 22/09/2026 (décision Valentin). Coupe-circuit :
  ?pers-blur=0 (localStorage persBlur).
==============================================================================*/
(function () {
  var gate = null;
  try {
    var m = location.search.match(/[?&]pers-blur=(0|1)/);
    if (m) localStorage.setItem('persBlur', m[1]);
    gate = localStorage.getItem('persBlur');
  } catch (e) {}
  if (gate === '0') return;
  if (window.innerWidth < 1024) return;
  document.documentElement.classList.add('pers-blur-active');

  var el = null, hideT = null;

  function closeNative() {
    var c = document.querySelector('.js-close-header-cart');
    if (c) { c.click(); return; }
    var hc = document.getElementById('HeaderCart');
    if (hc) hc.classList.remove('is-active');
  }
  function ensure() {
    if (el) return el;
    el = document.createElement('div');
    el.className = 'pers-cart-backdrop';
    el.setAttribute('aria-hidden', 'true');
    el.style.display = 'none';
    el.addEventListener('click', closeNative);
    document.body.appendChild(el);
    return el;
  }
  function isOpen() {
    var hc = document.getElementById('HeaderCart');
    return !!(hc && hc.classList.contains('is-active'));
  }
  function sync() {
    if (isOpen()) {
      clearTimeout(hideT);
      var b = ensure();
      b.style.display = '';
      /* deux frames : la transition d'opacité doit partir de display rendu */
      requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.add('is-visible'); }); });
    } else if (el) {
      el.classList.remove('is-visible');
      clearTimeout(hideT);
      hideT = setTimeout(function () { el.style.display = 'none'; }, 400);
    }
  }
  function start() {
    var hc = document.getElementById('HeaderCart');
    if (!hc) return;
    new MutationObserver(sync).observe(hc, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && isOpen()) closeNative();
    });
    sync();
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();

/*============================================================================
  Quick shop de la home (22/09/2026) — test Triple Exfoliant
  ----------------------------------------------------------------------------
  Carte flottante en bas à droite de la home (body.template-index) : visuel,
  « Nouveau », nom, prix (lu sur /products/<handle>.js, devise du marché),
  bouton « Ajouter au panier » → POST /cart/add.js (propriété cachée
  _source: home_quickshop, mesurable sur les commandes) puis ouverture du
  drawer via l'événement ajaxProduct:added du thème (repli : clic sur
  l'icône panier). Produit déjà au panier → « Voir mon panier ». Croix =
  masque la carte pour la page en cours seulement, elle revient à la
  prochaine visite/rechargement (pas de mémorisation, 22/09/2026).
  La bulle JOIN Stories est masquée sur la home tant que la carte est active
  (classe html.pers-qs-active, CSS). Pas d'abonnement proposé : le Triple
  Exfoliant n'a aucun plan de vente (selling_plan_groups vide au 22/09).
  ACTIF PAR DÉFAUT depuis le 22/09/2026 (décision Valentin, vu le déclin de
  JOIN sur 90 j : vues -45,55 %, revenu attribué faible et 100% indirect,
  cf. dashboard studio.join-stories.com). Coupe-circuit : ?pers-qs=0
  (localStorage persQs).
==============================================================================*/
(function () {
  var gate = null;
  try {
    var m = location.search.match(/[?&]pers-qs=(0|1)/);
    if (m) localStorage.setItem('persQs', m[1]);
    gate = localStorage.getItem('persQs');
  } catch (e) {}
  if (gate === '0') return;

  var PRODUCT = {
    id: 9759328665947,
    variant: 50122346660187,
    handle: 'duo-serum-haute-concentration',
    handleEn: 'duo-serum-high-concentration',
    title: 'Duo Sérums',
    titleEn: 'Serum Duo'
  };
  var en = /^\/en(\/|$)/.test(location.pathname);
  var langRoot = (location.pathname.match(/^\/(en(?:-[a-z]{2})?)(\/|$)/) || [])[1];
  var root = langRoot ? '/' + langRoot : '';
  var url = root + '/products/' + (en ? PRODUCT.handleEn : PRODUCT.handle);
  var T = en
    ? { kicker: 'Gift idea', add: 'Add to cart', adding: 'Adding…', added: 'Added', view: 'View my cart', close: 'Close', region: 'Quick shop' }
    : { kicker: 'Idée cadeau', add: 'Ajouter au panier', adding: 'Ajout…', added: 'Ajouté', view: 'Voir mon panier', close: 'Fermer', region: 'Achat rapide' };

  function fmt(minor) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var n = minor / 100;
    if (cur === 'EUR') return (Math.round(n) === n ? String(n) : n.toFixed(2).replace('.', ',')) + ' €';
    var s = Math.round(n) === n ? String(n) : n.toFixed(2);
    if (cur === 'GBP') return '£' + s;
    if (cur === 'USD') return '$' + s;
    return s + ' ' + cur;
  }
  function openDrawer() {
    var hc = document.getElementById('HeaderCart');
    if (hc && hc.classList.contains('is-active')) return;
    var link = document.querySelector('a.site-nav__link--icon[href$="/cart"]');
    if (link) link.click();
  }
  function inCart(cb) {
    fetch(root + '/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var found = false;
        for (var i = 0; i < c.items.length; i++) if (String(c.items[i].variant_id) === String(PRODUCT.variant)) found = true;
        cb(found);
      })
      .catch(function () { cb(false); });
  }

  function build(p) {
    /* pers-qs-active est déjà posée par start() (masquage JOIN anticipé,
       avant même cette requête réseau — cf. commentaire de start()). */
    var title = en ? PRODUCT.titleEn : PRODUCT.title;
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=180' : '';
    var card = document.createElement('div');
    card.className = 'pers-qs';
    card.setAttribute('role', 'region');
    card.setAttribute('aria-label', T.region);
    card.innerHTML =
      '<button type="button" class="pers-qs__close" aria-label="' + T.close + '">×</button>' +
      '<a class="pers-qs__img" href="' + url + '">' + (img ? '<img src="' + img + '" alt="" width="60" height="76">' : '') + '</a>' +
      '<div class="pers-qs__body">' +
        '<span class="pers-qs__kicker">' + T.kicker + '</span>' +
        '<a class="pers-qs__title" href="' + url + '">' + title + '</a>' +
        '<span class="pers-qs__price">' + fmt(p.price) + '</span>' +
      '</div>' +
      '<button type="button" class="pers-qs__btn">' + T.add + '</button>';
    document.body.appendChild(card);
    requestAnimationFrame(function () { requestAnimationFrame(function () { card.classList.add('is-visible'); }); });

    var btn = card.querySelector('.pers-qs__btn');
    var mode = 'add';
    function setView() { mode = 'view'; btn.textContent = T.view; btn.classList.remove('is-added'); btn.disabled = false; }
    inCart(function (f) { if (f) setView(); });

    btn.addEventListener('click', function () {
      if (mode === 'view') { openDrawer(); return; }
      if (btn.disabled) return;
      btn.disabled = true; btn.textContent = T.adding;
      var cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || (root + '/cart/add.js');
      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: PRODUCT.variant, quantity: 1, properties: { _source: 'home_quickshop', _device: window.innerWidth < 768 ? 'mobile' : 'desktop' } }] })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status === 422 || data.status === 'bad_request') throw new Error(data.description || data.message || 'add failed');
        btn.textContent = T.added; btn.classList.add('is-added');
        if (typeof gtag !== 'undefined') {
          gtag('event', 'add_to_cart', { currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR', value: p.price / 100,
            items: [{ item_id: String(PRODUCT.variant), item_name: title, item_category: 'Home quick shop', price: p.price / 100, quantity: 1 }] });
        }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { variant_id: PRODUCT.variant, product: data, from_quickshop: true } }));
        setTimeout(openDrawer, 400);
        setTimeout(setView, 1500);
      })
      .catch(function (e) {
        btn.disabled = false; btn.textContent = T.add;
        if (window.console) console.warn('Quick shop :', e && e.message);
      });
    });
    card.querySelector('.pers-qs__close').addEventListener('click', function () {
      /* Pas de mémorisation (retiré 22/09/2026) : phase de test, la carte
         doit rester la plus exposée possible. Fermer = "pas maintenant,
         pas cette page-ci", pas "plus jamais" — elle revient à la
         prochaine visite de la home, y compris un simple rechargement. */
      card.classList.remove('is-visible');
      document.documentElement.classList.remove('pers-qs-active');
      setTimeout(function () { card.remove(); }, 400);
    });
  }

  function start() {
    if (!document.body || !document.body.classList.contains('template-index')) return;
    /* Masquage de la bulle JOIN posé ICI, avant la requête réseau qui suit :
       sinon JOIN a le temps de s'afficher (script tiers, pas de dépendance
       réseau) puis de disparaître au chargement du produit, d'où le
       scintillement observé (22/09/2026). Filet de sécurité : si le produit
       est indisponible ou la requête échoue, la classe est retirée et JOIN
       reste affiché normalement. */
    document.documentElement.classList.add('pers-qs-active');
    fetch(url + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p || !p.available) { document.documentElement.classList.remove('pers-qs-active'); return; }
        build(p);
      })
      .catch(function () { document.documentElement.classList.remove('pers-qs-active'); });
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
